import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { IVariantInventory, Inventory } from "../../utils/api";
import { useAuth } from "../useAuth";

export interface IUpdateVariantThresholdsValues {
    /** Null inherits the global default; omit to leave the stored value. */
    floorCap?: number | null;
    restockCap?: number | null;
    active?: boolean;
}

export const useUpdateVariantThresholds = (
    variantId: string,
): UseMutationResult<
    IVariantInventory,
    unknown,
    IUpdateVariantThresholdsValues
> => {
    const { token } = useAuth();
    const queryClient = useQueryClient();

    return useMutation<
        IVariantInventory,
        unknown,
        IUpdateVariantThresholdsValues
    >({
        mutationFn: async (values: IUpdateVariantThresholdsValues) => {
            if (!token) {
                throw new Error(
                    "Cannot update stock thresholds without authorization token.",
                );
            }

            return await Inventory.updateThresholds({
                variantId,
                ...values,
                token,
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(["inventory", variantId]);
        },
    });
};
